module.exports = __webpack_public_path__ + "img/alliedworld.e9d675c0.png";